export default "__VITE_ASSET__4f5e2193__"